/**
 * Közös komponensek szövegei
 *
 * Namespace: components
 */
export const components = {
  // Error Boundary
  errorBoundary: {
    title: "Hiba történt",
    message: "Sajnáljuk, váratlan hiba lépett fel. Kérjük, próbáld újra.",
    technicalDetails: "Technikai részletek",
    retryButton: "Próbáld újra",
  },

  // Accessibility (akadálymentesítés)
  accessibility: {
    loading: "Betöltés...",
    required: "kötelező",
    closeButton: "Bezárás",
    dismissAlert: "Értesítés elvetése",
    showPassword: "Jelszó megjelenítése",
    hidePassword: "Jelszó elrejtése",
  },

  // Jelszóerősség indikátor
  passwordStrength: {
    weak: "Gyenge",
    medium: "Közepes",
    strong: "Erős",
    veryStrong: "Nagyon erős",
  },
} as const;

export type ComponentsMessages = typeof components;
